"use strict";
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            if (this == null) {
                throw TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            var len = o.length >>> 0;
            if (typeof predicate !== 'function') {
                throw TypeError('predicate must be a function');
            }
            var thisArg = arguments[1];
            var k = 0;
            while (k < len) {
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                k++;
            }
            return undefined;
        },
        configurable: true,
        writable: true
    });
}
(function (Window) {
    var moneyFormats = {
        "USD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} USD"
        },
        "EUR": {
            "money_format": "&euro;{{amount}}",
            "money_with_currency_format": "&euro;{{amount}} EUR"
        },
        "GBP": {
            "money_format": "&pound;{{amount}}",
            "money_with_currency_format": "&pound;{{amount}} GBP"
        },
        "CAD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} CAD"
        },
        "ALL": {
            "money_format": "Lek {{amount}}",
            "money_with_currency_format": "Lek {{amount}} ALL"
        },
        "DZD": {
            "money_format": "DA {{amount}}",
            "money_with_currency_format": "DA {{amount}} DZD"
        },
        "AOA": {
            "money_format": "Kz{{amount}}",
            "money_with_currency_format": "Kz{{amount}} AOA"
        },
        "ARS": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
        },
        "AMD": {
            "money_format": "{{amount}} AMD",
            "money_with_currency_format": "{{amount}} AMD"
        },
        "AWG": {
            "money_format": "Afl{{amount}}",
            "money_with_currency_format": "Afl{{amount}} AWG"
        },
        "AUD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} AUD"
        },
        "BBD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} Bds"
        },
        "AZN": {
            "money_format": "m.{{amount}}",
            "money_with_currency_format": "m.{{amount}} AZN"
        },
        "BDT": {
            "money_format": "Tk {{amount}}",
            "money_with_currency_format": "Tk {{amount}} BDT"
        },
        "BSD": {
            "money_format": "BS${{amount}}",
            "money_with_currency_format": "BS${{amount}} BSD"
        },
        "BHD": {
            "money_format": "{{amount}}0 BD",
            "money_with_currency_format": "{{amount}}0 BHD"
        },
        "BYR": {
            "money_format": "Br {{amount}}",
            "money_with_currency_format": "Br {{amount}} BYR"
        },
        "BIF": {
            "money_format": "FBu {{amount}}",
            "money_with_currency_format": "FBu {{amount}} BIF"
        },
        "BZD": {
            "money_format": "BZ${{amount}}",
            "money_with_currency_format": "BZ${{amount}} BZD"
        },
        "BTN": {
            "money_format": "Nu {{amount}}",
            "money_with_currency_format": "Nu {{amount}} BTN"
        },
        "BAM": {
            "money_format": "KM {{amount_with_comma_separator}}",
            "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
        },
        "BRL": {
            "money_format": "R$ {{amount_with_comma_separator}}",
            "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
        },
        "BOB": {
            "money_format": "Bs{{amount_with_comma_separator}}",
            "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
        },
        "BWP": {
            "money_format": "P{{amount}}",
            "money_with_currency_format": "P{{amount}} BWP"
        },
        "BND": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} BND"
        },
        "BGN": {
            "money_format": "{{amount}} лв",
            "money_with_currency_format": "{{amount}} лв BGN"
        },
        "MMK": {
            "money_format": "K{{amount}}",
            "money_with_currency_format": "K{{amount}} MMK"
        },
        "KHR": {
            "money_format": "KHR{{amount}}",
            "money_with_currency_format": "KHR{{amount}}"
        },
        "KYD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} KYD"
        },
        "XAF": {
            "money_format": "FCFA{{amount}}",
            "money_with_currency_format": "FCFA{{amount}} XAF"
        },
        "CLP": {
            "money_format": "${{amount_no_decimals}}",
            "money_with_currency_format": "${{amount_no_decimals}} CLP"
        },
        "CNY": {
            "money_format": "&#165;{{amount}}",
            "money_with_currency_format": "&#165;{{amount}} CNY"
        },
        "COP": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} COP"
        },
        "CRC": {
            "money_format": "&#8353; {{amount_with_comma_separator}}",
            "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
        },
        "HRK": {
            "money_format": "{{amount_with_comma_separator}} kn",
            "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
        },
        "CZK": {
            "money_format": "{{amount}} K&#269;",
            "money_with_currency_format": "{{amount}} K&#269;"
        },
        "DKK": {
            "money_format": "kr.{{amount_with_comma_separator}}",
            "money_with_currency_format": "kr.{{amount_with_comma_separator}}"
        },
        "DOP": {
            "money_format": "RD$ {{amount}}",
            "money_with_currency_format": "RD$ {{amount}}"
        },
        "XCD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "EC${{amount}}"
        },
        "EGP": {
            "money_format": "LE {{amount}}",
            "money_with_currency_format": "LE {{amount}} EGP"
        },
        "ETB": {
            "money_format": "Br{{amount}}",
            "money_with_currency_format": "Br{{amount}} ETB"
        },
        "XPF": {
            "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
        },
        "FJD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "FJ${{amount}}"
        },
        "GMD": {
            "money_format": "D {{amount}}",
            "money_with_currency_format": "D {{amount}} GMD"
        },
        "GHS": {
            "money_format": "GH&#8373;{{amount}}",
            "money_with_currency_format": "GH&#8373;{{amount}}"
        },
        "GTQ": {
            "money_format": "Q{{amount}}",
            "money_with_currency_format": "{{amount}} GTQ"
        },
        "GYD": {
            "money_format": "G${{amount}}",
            "money_with_currency_format": "${{amount}} GYD"
        },
        "GEL": {
            "money_format": "{{amount}} GEL",
            "money_with_currency_format": "{{amount}} GEL"
        },
        "HNL": {
            "money_format": "L {{amount}}",
            "money_with_currency_format": "L {{amount}} HNL"
        },
        "HKD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "HK${{amount}}"
        },
        "HUF": {
            "money_format": "{{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
        },
        "ISK": {
            "money_format": "{{amount_no_decimals}} kr",
            "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
        },
        "INR": {
            "money_format": "Rs. {{amount}}",
            "money_with_currency_format": "Rs. {{amount}}"
        },
        "IDR": {
            "money_format": "{{amount_with_comma_separator}}",
            "money_with_currency_format": "Rp {{amount_with_comma_separator}}"
        },
        "ILS": {
            "money_format": "{{amount}} NIS",
            "money_with_currency_format": "{{amount}} NIS"
        },
        "JMD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} JMD"
        },
        "JPY": {
            "money_format": "&#165;{{amount_no_decimals}}",
            "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
        },
        "JEP": {
            "money_format": "&pound;{{amount}}",
            "money_with_currency_format": "&pound;{{amount}} JEP"
        },
        "JOD": {
            "money_format": "{{amount}}0 JD",
            "money_with_currency_format": "{{amount}}0 JOD"
        },
        "KZT": {
            "money_format": "{{amount}} KZT",
            "money_with_currency_format": "{{amount}} KZT"
        },
        "KES": {
            "money_format": "KSh{{amount}}",
            "money_with_currency_format": "KSh{{amount}}"
        },
        "KWD": {
            "money_format": "{{amount}}0 KD",
            "money_with_currency_format": "{{amount}}0 KWD"
        },
        "KGS": {
            "money_format": "лв{{amount}}",
            "money_with_currency_format": "лв{{amount}}"
        },
        "LVL": {
            "money_format": "Ls {{amount}}",
            "money_with_currency_format": "Ls {{amount}} LVL"
        },
        "LBP": {
            "money_format": "L&pound;{{amount}}",
            "money_with_currency_format": "L&pound;{{amount}} LBP"
        },
        "LTL": {
            "money_format": "{{amount}} Lt",
            "money_with_currency_format": "{{amount}} Lt"
        },
        "MGA": {
            "money_format": "Ar {{amount}}",
            "money_with_currency_format": "Ar {{amount}} MGA"
        },
        "MKD": {
            "money_format": "ден {{amount}}",
            "money_with_currency_format": "ден {{amount}} MKD"
        },
        "MOP": {
            "money_format": "MOP${{amount}}",
            "money_with_currency_format": "MOP${{amount}}"
        },
        "MVR": {
            "money_format": "Rf{{amount}}",
            "money_with_currency_format": "Rf{{amount}} MRf"
        },
        "MXN": {
            "money_format": "$ {{amount}}",
            "money_with_currency_format": "$ {{amount}} MXN"
        },
        "MYR": {
            "money_format": "RM{{amount}} MYR",
            "money_with_currency_format": "RM{{amount}} MYR"
        },
        "MUR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} MUR"
        },
        "MDL": {
            "money_format": "{{amount}} MDL",
            "money_with_currency_format": "{{amount}} MDL"
        },
        "MAD": {
            "money_format": "{{amount}} dh",
            "money_with_currency_format": "Dh {{amount}} MAD"
        },
        "MNT": {
            "money_format": "{{amount_no_decimals}} &#8366",
            "money_with_currency_format": "{{amount_no_decimals}} MNT"
        },
        "MZN": {
            "money_format": "{{amount}} Mt",
            "money_with_currency_format": "Mt {{amount}} MZN"
        },
        "NAD": {
            "money_format": "N${{amount}}",
            "money_with_currency_format": "N${{amount}} NAD"
        },
        "NPR": {
            "money_format": "Rs{{amount}}",
            "money_with_currency_format": "Rs{{amount}} NPR"
        },
        "ANG": {
            "money_format": "&fnof;{{amount}}",
            "money_with_currency_format": "{{amount}} NA&fnof;"
        },
        "NZD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} NZD"
        },
        "NIO": {
            "money_format": "C${{amount}}",
            "money_with_currency_format": "C${{amount}} NIO"
        },
        "NGN": {
            "money_format": "&#8358;{{amount}}",
            "money_with_currency_format": "&#8358;{{amount}} NGN"
        },
        "NOK": {
            "money_format": "kr {{amount_with_comma_separator}}",
            "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
        },
        "OMR": {
            "money_format": "{{amount_with_comma_separator}} OMR",
            "money_with_currency_format": "{{amount_with_comma_separator}} OMR"
        },
        "PKR": {
            "money_format": "Rs.{{amount}}",
            "money_with_currency_format": "Rs.{{amount}} PKR"
        },
        "PGK": {
            "money_format": "K {{amount}}",
            "money_with_currency_format": "K {{amount}} PGK"
        },
        "PYG": {
            "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
        },
        "PEN": {
            "money_format": "S/. {{amount}}",
            "money_with_currency_format": "S/. {{amount}} PEN"
        },
        "PHP": {
            "money_format": "&#8369;{{amount}}",
            "money_with_currency_format": "&#8369;{{amount}} PHP"
        },
        "PLN": {
            "money_format": "{{amount_with_comma_separator}} zl",
            "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
        },
        "QAR": {
            "money_format": "QAR {{amount_with_comma_separator}}",
            "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
        },
        "RON": {
            "money_format": "{{amount_with_comma_separator}} lei",
            "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
        },
        "RUB": {
            "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
            "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
        },
        "RWF": {
            "money_format": "{{amount_no_decimals}} RF",
            "money_with_currency_format": "{{amount_no_decimals}} RWF"
        },
        "WST": {
            "money_format": "WS$ {{amount}}",
            "money_with_currency_format": "WS$ {{amount}} WST"
        },
        "SAR": {
            "money_format": "{{amount}} SR",
            "money_with_currency_format": "{{amount}} SAR"
        },
        "STD": {
            "money_format": "Db {{amount}}",
            "money_with_currency_format": "Db {{amount}} STD"
        },
        "RSD": {
            "money_format": "{{amount}} RSD",
            "money_with_currency_format": "{{amount}} RSD"
        },
        "SCR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} SCR"
        },
        "SGD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} SGD"
        },
        "SYP": {
            "money_format": "S&pound;{{amount}}",
            "money_with_currency_format": "S&pound;{{amount}} SYP"
        },
        "ZAR": {
            "money_format": "R {{amount}}",
            "money_with_currency_format": "R {{amount}} ZAR"
        },
        "KRW": {
            "money_format": "&#8361;{{amount_no_decimals}}",
            "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
        },
        "LKR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} LKR"
        },
        "SEK": {
            "money_format": "{{amount_no_decimals}} kr",
            "money_with_currency_format": "{{amount_no_decimals}} kr SEK"
        },
        "CHF": {
            "money_format": "SFr. {{amount}}",
            "money_with_currency_format": "SFr. {{amount}} CHF"
        },
        "TWD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} TWD"
        },
        "THB": {
            "money_format": "{{amount}} &#xe3f;",
            "money_with_currency_format": "{{amount}} &#xe3f; THB"
        },
        "TZS": {
            "money_format": "{{amount}} TZS",
            "money_with_currency_format": "{{amount}} TZS"
        },
        "TTD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} TTD"
        },
        "TND": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} DT"
        },
        "TRY": {
            "money_format": "{{amount}}TL",
            "money_with_currency_format": "{{amount}}TL"
        },
        "UGX": {
            "money_format": "Ush {{amount_no_decimals}}",
            "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
        },
        "UAH": {
            "money_format": "₴{{amount}}",
            "money_with_currency_format": "₴{{amount}} UAH"
        },
        "AED": {
            "money_format": "Dhs. {{amount}}",
            "money_with_currency_format": "Dhs. {{amount}} AED"
        },
        "UYU": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
        },
        "VUV": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}}VT"
        },
        "VEF": {
            "money_format": "Bs. {{amount_with_comma_separator}}",
            "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
        },
        "VND": {
            "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
        },
        "XBT": {
            "money_format": "{{amount_no_decimals}} BTC",
            "money_with_currency_format": "{{amount_no_decimals}} BTC"
        },
        "XOF": {
            "money_format": "CFA{{amount}}",
            "money_with_currency_format": "CFA{{amount}} XOF"
        },
        "ZMW": {
            "money_format": "K{{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
        }
    };
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
    function applyCurrencyFormatting(cents, formatType) {
        switch (formatType) {
            case 'amount':
                return formatWithDelimiters(cents, 2);
            case 'amount_no_decimals':
                return formatWithDelimiters(cents, 0);
            case 'amount_with_comma_separator':
                return formatWithDelimiters(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
                return formatWithDelimiters(cents, 0, '.', ',');
            default:
                return '';
        }
    }
    function formatWithDelimiters(number, precisionInput, thousandsInput, decimalInput, roundToInput) {
        if (isNaN(number) || number == null) {
            return '';
        }
        var precision = defaultOption(precisionInput, 2);
        var thousands = defaultOption(thousandsInput, ' ');
        var decimal = defaultOption(decimalInput, '.');
        var fixedNumber = (number / 100.0);
        if (roundToInput && roundToInput > 0) {
            fixedNumber = Math.round(fixedNumber / roundToInput) * roundToInput;
        }
        var fixedNumberFinal = fixedNumber.toFixed(precision);
        var parts = fixedNumberFinal.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents = parts[1] ? (decimal + parts[1]) : '';
        return "".concat(dollars).concat(cents);
    }
    function formatMoney(cents, format) {
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || '${{amount}}';
        var formatMatch = formatString.match(placeholderRegex);
        if (formatMatch && formatMatch.length >= 2) {
            var currencyFormatting = formatMatch[1];
            value = applyCurrencyFormatting(cents, currencyFormatting);
        }
        return formatString.replace(placeholderRegex, value);
    }
    function convert(currentAmount, baseCurrency, newCurrency) {
        if (Window.Currency && Window.Currency.convert instanceof Function) {
            return Window.Currency.convert(currentAmount, baseCurrency, newCurrency);
        }
        var currencyRates = Window.Currency && Window.Currency.rates ? Window.Currency.rates : {};
        var baseCurrencyRate = currencyRates[baseCurrency];
        var newCurrencyRate = currencyRates[newCurrency];
        if (!baseCurrencyRate || !newCurrencyRate) {
            return currentAmount;
        }
        return currentAmount * currencyRates[baseCurrency] / currencyRates[newCurrency];
    }
    function getAmount(element, baseFormat, baseCurrency) {
        var htmlContent = element.innerText;
        var priceMatches = htmlContent.match(/[0-9., ]+/);
        if (!priceMatches || priceMatches.length === 0) {
            return NaN;
        }
        var priceValue = priceMatches[0].trim();
        var priceValuePartsWithDot = priceValue.split('.');
        var pricevaluePartsWithComma = priceValue.split(',');
        var hasDotDecimalDelimiter = priceValuePartsWithDot.length > 1 && (priceValuePartsWithDot[1].length == 1 || priceValuePartsWithDot[1].length == 2);
        var hasCommaDecimalDelimiter = pricevaluePartsWithComma.length > 1 && (pricevaluePartsWithComma[1].length == 1 || pricevaluePartsWithComma[1].length == 2);
        if (!hasDotDecimalDelimiter && !hasCommaDecimalDelimiter) {
            return parseInt(priceValue.replace(/[^0-9]/g, ''), 10) * 100;
        }
        if (hasDotDecimalDelimiter || hasCommaDecimalDelimiter) {
            return parseInt(priceValue.replace(/[^0-9]/g, ''), 10);
        }
        if (baseFormat.indexOf('amount_no_decimals') !== -1) {
            return parseInt(priceValue.replace(/[^0-9]/g, ''), 10) * 100;
        }
        if (baseCurrency === 'JOD' || baseCurrency === 'KWD' || baseCurrency === 'BHD') {
            return parseInt(priceValue.replace(/[^0-9]/g, ''), 10) / 10;
        }
        return parseInt(priceValue.replace(/[^0-9]/g, ''), 10);
    }
    function getCurrencyFormat(currency, format, themeMoneyFormat) {
        var currencyFormats = moneyFormats[currency];
        var currencyFormat = currencyFormats
            ? currencyFormats[format] || "{{amount}} ".concat(currency)
            : "{{amount}} ".concat(currency);
        if (themeMoneyFormat && themeMoneyFormat.indexOf('amount_no_decimals') > -1 && currencyFormat.indexOf('custom_') === -1) {
            return currencyFormat.replace(/{{(([^}][^}]?|[^}]}?)*)}}/, '{{amount_no_decimals}}');
        }
        return currencyFormat;
    }
    function convertAll(baseCurrency, oldCurrency, newCurrency, selector) {
        if (!newCurrency) {
            return;
        }
        document.querySelectorAll(selector || 'span.money').forEach(function (moneyElement) {
            var baseFormat = getCurrencyFormat(baseCurrency, currencyHandler.format);
            var newFormat = getCurrencyFormat(newCurrency, currencyHandler.format);
            var currentAmount = getAmount(moneyElement, baseFormat, baseCurrency);
            if (isNaN(currentAmount)) {
                return;
            }
            if (!moneyElement.getAttribute('data-base-currency')) {
                moneyElement.setAttribute('data-base-currency', baseCurrency);
                moneyElement.setAttribute('data-base-amount', currentAmount.toString());
            }
            else {
                var baseAmmount = moneyElement.getAttribute('data-base-amount');
                if (baseAmmount) {
                    currentAmount = parseFloat(baseAmmount);
                }
            }
            if (moneyElement.getAttribute('data-currency') === newCurrency) {
                return;
            }
            var newCurrencyDataAttribute = "data-currency-".concat(newCurrency);
            var dataNewCurrency = moneyElement.getAttribute(newCurrencyDataAttribute);
            if (dataNewCurrency) {
                moneyElement.innerHTML = dataNewCurrency;
            }
            else {
                var cents = convert(currentAmount, baseCurrency, newCurrency);
                var newFormattedAmount = formatMoney(cents, newFormat);
                moneyElement.innerHTML = newFormattedAmount;
                moneyElement.setAttribute(newCurrencyDataAttribute, newFormattedAmount);
            }
            moneyElement.setAttribute('data-currency', newCurrency);
        });
    }
    var currencyCookie = {
        name: 'translation-lab-currency',
        write: function (currency) {
            Window.localStorage.setItem(this.name, currency);
        },
        read: function () {
            return Window.localStorage.getItem(this.name);
        },
        destroy: function () {
            Window.localStorage.removeItem(this.name);
        }
    };
    var currencyHandler = {
        cookie: currencyCookie,
        format: 'money_with_currency_format',
        themeMoneyFormat: '',
        themeMoneyWithCurrencyFormat: '',
        convertAll: convertAll
    };
    if (typeof Window.TranslationLab === 'undefined') {
        Window.TranslationLab = {};
    }
    if (typeof Window.TranslationLab.Currency === 'undefined') {
        Window.TranslationLab.Currency = currencyHandler;
    }
})(window);
(function (Window) {
    var imgFileTemplate = 'https://shopify-script-tags.s3.eu-west-1.amazonaws.com/tlab-flag-images/[country-code].png';
    function buildRedirectUrl(redirectLanguage, currentLocale, shopDomain, useInternationalDomains) {
        if (!redirectLanguage || !currentLocale) {
            return null;
        }
        var redirectLocaleLower = redirectLanguage.iso_code.toLowerCase();
        var currentLocaleLower = currentLocale.toLowerCase();
        if (currentLocaleLower === redirectLocaleLower) {
            return null;
        }
        var pathnameWithLocale = Window.location.pathname;
        var queryString = Window.location.search || '';
        var currentLocaleRegEx = new RegExp("^/".concat(currentLocaleLower), "ig");
        var pathname = pathnameWithLocale.replace(currentLocaleRegEx, '');
        if (useInternationalDomains) {
            return "https://".concat(redirectLanguage.domain).concat(pathname).concat(queryString);
        }
        if (redirectLanguage.root_url === '/') {
            return "https://".concat(shopDomain).concat(pathname).concat(queryString);
        }
        return "https://".concat(shopDomain).concat(redirectLanguage.root_url).concat(pathname).concat(queryString);
    }
    function getCurrenciesForLanguage(languageCode, languageCurrencies, defaultCurrencyCode) {
        if (!languageCode || !languageCurrencies) {
            return {
                languageCode: '',
                currencies: [
                    {
                        code: defaultCurrencyCode
                    }
                ]
            };
        }
        var langCodePart = languageCode.split('-')[0];
        var langCurrencyMapping = languageCurrencies.find(function (x) { return x.languageCode === languageCode || x.languageCode === langCodePart; });
        var defaultCurrenciesForLanguage = {
            languageCode: languageCode,
            currencies: [
                {
                    code: defaultCurrencyCode
                }
            ]
        };
        return langCurrencyMapping !== null && langCurrencyMapping !== void 0 ? langCurrencyMapping : defaultCurrenciesForLanguage;
    }
    function findCurrencyForLanguage(langCurrencies, languageCode, currencyCode, defaultCurrencyCode) {
        if (!languageCode) {
            return null;
        }
        var langCurrencyMapping = getCurrenciesForLanguage(languageCode, langCurrencies, defaultCurrencyCode);
        var currency = langCurrencyMapping.currencies.find(function (currency) { return currency.code === currencyCode; });
        if (!currency) {
            return langCurrencyMapping.currencies[0];
        }
        return currency;
    }
    function dropdownHandler(configuration) {
        var isOpen = false;
        var container = document.getElementById(configuration.containerId);
        if (!container) {
            return null;
        }
        var dropdown = container.querySelector(configuration.dropdownSelector);
        var itemList = container.querySelector(configuration.optionsListSelector);
        if (!dropdown) {
            return null;
        }
        var itemLabel = dropdown.getElementsByTagName('span')[0];
        var itemImage = dropdown.getElementsByTagName('img')[0];
        dropdown.addEventListener('click', toggleDropdown, false);
        document.addEventListener('click', handleOutsideClick, false);
        if (itemList && itemList.children) {
            Array.prototype.forEach.call(itemList.children, function (listItemElement) {
                listItemElement.addEventListener('click', function () { return selectItem(listItemElement); });
            });
        }
        var oldSelection = undefined;
        var currentSelection = configuration.itemList.find(function (item) { return configuration.selectedItem && item.iso_code.toLowerCase() === configuration.selectedItem.toLowerCase(); });
        function selectItem(element) {
            close();
            var itemCode = element.dataset.value;
            if (!itemCode) {
                return;
            }
            var selectedItem = configuration.itemList.find(function (item) { return item.iso_code.toLowerCase() === itemCode.toLowerCase(); });
            if (!selectedItem) {
                return;
            }
            oldSelection = currentSelection;
            currentSelection = selectedItem;
            var selectedItemLabel = element.getElementsByTagName('span')[0];
            var selectedItemImage = element.getElementsByTagName('img')[0];
            if (selectedItemLabel) {
                itemLabel.textContent = selectedItemLabel.textContent;
            }
            else if (configuration.generateLabel instanceof Function) {
                itemLabel.textContent = configuration.generateLabel(selectedItem);
            }
            if (itemImage && selectedItemImage) {
                itemImage.src = selectedItemImage.src;
            }
            if (configuration.onItemSelect instanceof Function) {
                configuration.onItemSelect(selectedItem, container);
            }
        }
        function resetSelection() {
            if (oldSelection) {
                if (configuration.generateLabel instanceof Function) {
                    itemLabel.textContent = configuration.generateLabel(oldSelection);
                }
                if (itemImage) {
                    itemImage.src = oldSelection.flag;
                }
                currentSelection = oldSelection;
                oldSelection = undefined;
            }
        }
        function getSelectedItem() {
            return currentSelection;
        }
        function toggleDropdown(event) {
            event.preventDefault();
            if (isOpen) {
                close();
            }
            else {
                open();
            }
        }
        function handleOutsideClick(event) {
            if (!isOpen || event.target === dropdown) {
                return;
            }
            var path = event.composedPath();
            for (var i = 0; i < path.length; i++) {
                if (path[i] === dropdown) {
                    return;
                }
            }
            close();
        }
        function open() {
            isOpen = true;
            dropdown.classList.add('open');
            itemList.classList.add('open');
        }
        function close() {
            isOpen = false;
            dropdown.classList.remove('open');
            itemList.classList.remove('open');
        }
        return {
            selectItem: selectItem,
            resetSelection: resetSelection,
            getSelectedItem: getSelectedItem,
            container: container
        };
    }
    function currencySelectorHandler(selectorConfig, currentCurrencyCode, currencies) {
        var isOpen = false;
        var container = document.getElementById(selectorConfig.currencySwitcherId);
        if (!container) {
            return null;
        }
        var dropdown = container.querySelector(selectorConfig.dropdownSelector);
        var itemList = container.querySelector(selectorConfig.optionsListSelector);
        if (!dropdown) {
            return null;
        }
        dropdown.addEventListener('click', toggleDropdown, false);
        document.addEventListener('click', handleOutsideClick, false);
        var oldSelection = undefined;
        var currentSelection = currencies.find(function (item) { return item.code.toLowerCase() === currentCurrencyCode.toLowerCase(); });
        function selectItem(selectedItem) {
            close();
            if (!selectedItem) {
                return;
            }
            oldSelection = currentSelection;
            currentSelection = selectedItem;
            document.querySelectorAll('div.tl-dropdown.currency-selection').forEach(function (el) {
                var sp = el.getElementsByTagName('span')[0];
                var img = el.getElementsByTagName('img')[0];
                sp.textContent = selectedItem.code;
                if (img) {
                    img.src = imgFileTemplate.replace('[country-code]', selectedItem.code.slice(0, 2).toLowerCase());
                }
            });
        }
        function resetSelection() {
            if (!oldSelection) {
                return;
            }
            document.querySelectorAll('div.tl-dropdown.currency-selection').forEach(function (el) {
                var sp = el.getElementsByTagName('span')[0];
                var img = el.getElementsByTagName('img')[0];
                sp.textContent = oldSelection.code;
                if (img) {
                    img.src = imgFileTemplate.replace('[country-code]', oldSelection.code.slice(0, 2).toLowerCase());
                }
            });
            currentSelection = oldSelection;
        }
        function getCurrentSelection() {
            return currentSelection;
        }
        function toggleDropdown(event) {
            event.preventDefault();
            if (isOpen) {
                close();
            }
            else {
                open();
            }
        }
        function handleOutsideClick(event) {
            if (!isOpen || event.target === dropdown) {
                return;
            }
            var path = event.composedPath();
            for (var i = 0; i < path.length; i++) {
                if (path[i] === dropdown) {
                    return;
                }
            }
            close();
        }
        function open() {
            isOpen = true;
            dropdown.classList.add('open');
            itemList.classList.add('open');
        }
        function close() {
            isOpen = false;
            dropdown.classList.remove('open');
            itemList.classList.remove('open');
        }
        return {
            selectItem: selectItem,
            resetSelection: resetSelection,
            getCurrentSelection: getCurrentSelection,
            openDropdown: open,
            closeDropdown: close
        };
    }
    function dropdownContainerHandler(configuration, cancelAction, acceptAction) {
        var isMainDropdownOpen = false;
        var popupId = configuration.popupId;
        var container = document.getElementById(configuration.currentSelectionsId);
        if (!container) {
            return;
        }
        container.addEventListener('click', toggleDropdown);
        var closeButtons = document.querySelectorAll('.modal-close-btn');
        if (closeButtons && closeButtons.length > 0) {
            closeButtons.forEach(function (el) {
                el.addEventListener('click', close);
            });
        }
        var saveButton = document.getElementById(configuration.submitButtonId);
        if (saveButton) {
            saveButton.addEventListener('click', saveSelection);
        }
        if (configuration.isModal) {
            configurePopupOverlay();
        }
        else {
            onOutsideClick(function () {
                close();
                if (cancelAction instanceof Function) {
                    cancelAction();
                }
            });
        }
        function toggleDropdown(event) {
            event.preventDefault();
            if (isMainDropdownOpen) {
                close();
            }
            else {
                open();
            }
        }
        function open() {
            var popupElement = document.getElementById(popupId);
            if (popupElement) {
                popupElement.classList.add('active');
            }
            isMainDropdownOpen = true;
        }
        function close() {
            var popupElement = document.getElementById(popupId);
            if (popupElement != null) {
                popupElement.classList.remove('active');
            }
            isMainDropdownOpen = false;
        }
        function onOutsideClick(callback) {
            var currencyWrapperClass = 'tl-wrapper';
            document.addEventListener('click', function (event) {
                if (!isMainDropdownOpen) {
                    return;
                }
                if (!event || !event.target) {
                    return;
                }
                var eventTarget = event.target;
                if (eventTarget.className && typeof eventTarget.className == 'string' && eventTarget.className.includes(currencyWrapperClass)) {
                    return;
                }
                var path = event.composedPath();
                for (var i = 0; i < path.length; i++) {
                    var pathEventTarget = path[i];
                    if (pathEventTarget.className && typeof pathEventTarget.className == 'string' && pathEventTarget.className.includes(currencyWrapperClass)) {
                        return;
                    }
                    if (pathEventTarget.className && typeof pathEventTarget.className == 'string' && pathEventTarget.className.includes('tl-switcher')) {
                        return;
                    }
                }
                callback();
            });
        }
        function saveSelection() {
            close();
            if (acceptAction instanceof Function) {
                acceptAction();
            }
        }
        function configurePopupOverlay() {
            var popupElement = document.getElementById(popupId);
            if (popupElement) {
                popupElement.remove();
                document.body.appendChild(popupElement);
            }
        }
        return {
            openDropdown: open,
            closeDropdown: close
        };
    }
    function configureLanguageSwitcher(config, onLanguageSelectExternal) {
        var dropdownConfig = {
            containerId: config.languageSwitcherId,
            dropdownSelector: config.dropdownSelector,
            optionsListSelector: config.optionsListSelector,
            itemList: config.languageList,
            selectedItem: config.currentLocale,
            generateLabel: function (language) { return config.labelType === 'language-name' ? language.endonym_name : language.display_code; },
            onItemSelect: function (language, container) {
                if (!language) {
                    return;
                }
                if (onLanguageSelectExternal) {
                    onLanguageSelectExternal(language);
                }
                else {
                    localStorage.setItem('translation-lab-lang', language.iso_code);
                    if (config.useInternationalDomains) {
                        var redirectUrl = buildRedirectUrl(language, config.currentLocale, config.shopDomain, config.useInternationalDomains);
                        if (redirectUrl) {
                            Window.location.assign(redirectUrl);
                        }
                    }
                    else {
                        var form = container.querySelector('form');
                        if (!form) {
                            return;
                        }
                        var formInputElementResult = container.querySelector('input[name="language_code"]');
                        if (!formInputElementResult) {
                            return;
                        }
                        var formInputElement = formInputElementResult;
                        formInputElement.value = language.iso_code;
                        form.submit();
                    }
                }
            }
        };
        var switcher = dropdownHandler(dropdownConfig);
        if (!switcher) {
            return;
        }
        function acceptLanguageChange() {
            var languageToChange = switcher === null || switcher === void 0 ? void 0 : switcher.getSelectedItem();
            if (!languageToChange || languageToChange.iso_code === config.currentLocale) {
                return;
            }
            var redirectLanguage = config.languageList.find(function (language) { return language.iso_code.toLowerCase() === languageToChange.iso_code.toLowerCase(); });
            if (!redirectLanguage) {
                return;
            }
            localStorage.setItem('translation-lab-lang', languageToChange.iso_code);
            if (config.useInternationalDomains) {
                var redirectUrl = buildRedirectUrl(redirectLanguage, config.currentLocale, config.shopDomain, config.useInternationalDomains);
                if (redirectUrl) {
                    Window.location.assign(redirectUrl);
                }
            }
            else {
                var form = switcher === null || switcher === void 0 ? void 0 : switcher.container.querySelector('form');
                var formInputElement = switcher === null || switcher === void 0 ? void 0 : switcher.container.querySelector('input[name="language_code"]');
                formInputElement.value = redirectLanguage.iso_code;
                if (form) {
                    form.submit();
                }
            }
        }
        return {
            resetSelection: switcher.resetSelection,
            acceptLanguageChange: acceptLanguageChange
        };
    }
    function configureCurrencySwitcher(config, onCurrencySelectExternal) {
        var currentLanguage = config.languageList.find(function (language) { return language.iso_code.toLowerCase() === config.currentLocale.toLowerCase(); });
        if (!currentLanguage) {
            return;
        }
        var nextLanguage = currentLanguage;
        var languageCurrencies = config.langCurrencies;
        var langCurrencyMapping = getCurrenciesForLanguage(currentLanguage.iso_code, languageCurrencies, config.shopCurrencyCode);
        var currentCurrencyCode = getCurrentCurrencyCode(currentLanguage);
        var isCurrencyConversionOnDomChangeEnabled = true;
        var currencySelector = currencySelectorHandler(config, currentCurrencyCode, langCurrencyMapping.currencies);
        if (!currencySelector) {
            return;
        }
        updateCurrencyList(currentLanguage);
        sendCurrencyChangeEvent();
        configureDomChangeTracker(onDomChange);
        function onDomChange() {
            if (isCurrencyConversionOnDomChangeEnabled) {
                updatePriceElements(currentLanguage.iso_code, getCurrentCurrencyCode(currentLanguage));
            }
        }
        function getCurrentCurrencyCode(language) {
            var _a, _b, _c;
            var savedCurrencyCode = ((_c = (_b = (_a = Window.TranslationLab) === null || _a === void 0 ? void 0 : _a.Currency) === null || _b === void 0 ? void 0 : _b.cookie) === null || _c === void 0 ? void 0 : _c.read()) || config.shopCurrencyCode;
            var currencyForCurrentLanguage = findCurrencyForLanguage(languageCurrencies, language.iso_code, savedCurrencyCode, config.shopCurrencyCode);
            var currencyCode = currencyForCurrentLanguage ? currencyForCurrentLanguage.code : config.shopCurrencyCode;
            return currencyCode;
        }
        function updateCurrencyList(language) {
            nextLanguage = language;
            var langCurrencyMapping = getCurrenciesForLanguage(language.iso_code, languageCurrencies, config.shopCurrencyCode);
            var currencyOptionsElementResult = document.getElementById(config.currencyOptionsId);
            if (!currencyOptionsElementResult) {
                return;
            }
            var currencyOptionsElement = currencyOptionsElementResult;
            currencyOptionsElement.innerHTML = '';
            langCurrencyMapping.currencies.forEach(function (metafieldCurrency) {
                var li = document.createElement('li');
                li.classList.add('tl-option');
                if (config.showFlags) {
                    var itemImage = document.createElement('img');
                    itemImage.src = imgFileTemplate.replace('[country-code]', metafieldCurrency.code.slice(0, 2).toLowerCase());
                    itemImage.classList.add('tl-currency-flag');
                    li.appendChild(itemImage);
                }
                var itemLabel = document.createElement('span');
                itemLabel.classList.add('currency-label');
                itemLabel.innerText = metafieldCurrency.code;
                li.appendChild(itemLabel);
                li.addEventListener('click', listItemClick);
                currencyOptionsElement.appendChild(li);
                function listItemClick() {
                    if (!currencySelector) {
                        return;
                    }
                    currencySelector.selectItem(metafieldCurrency);
                    if (onCurrencySelectExternal) {
                        onCurrencySelectExternal(metafieldCurrency);
                    }
                    else {
                        acceptCurrencyChange(currentLanguage.iso_code, metafieldCurrency.code);
                    }
                }
            });
            updateCurrencySelection(language.iso_code, getCurrentCurrencyCode(language));
        }
        function acceptCurrencyChange(languageCode, targetCurrencyCode) {
            updateCurrencySelection(languageCode, targetCurrencyCode);
            applyCurrencyConversion(languageCode, targetCurrencyCode);
        }
        function acceptCurrencyChangeExternal() {
            if (!currencySelector) {
                return;
            }
            var currentSelection = currencySelector.getCurrentSelection();
            acceptCurrencyChange(nextLanguage.iso_code, currentSelection.code);
        }
        function resetSelection() {
            nextLanguage = currentLanguage;
            currencySelector === null || currencySelector === void 0 ? void 0 : currencySelector.resetSelection();
        }
        function updateCurrencySelection(languageCode, targetCurrencyCode) {
            if (!currencySelector) {
                return;
            }
            var targetCurrency = findCurrencyForLanguage(languageCurrencies, languageCode, targetCurrencyCode, config.shopCurrencyCode);
            if (!targetCurrency) {
                return;
            }
            currencySelector.selectItem(targetCurrency);
        }
        function applyCurrencyConversion(languageCode, targetCurrencyCode) {
            var targetCurrency = findCurrencyForLanguage(languageCurrencies, languageCode, targetCurrencyCode, config.shopCurrencyCode);
            if (!targetCurrency) {
                return;
            }
            currentCurrencyCode = targetCurrency.code;
            Window.TranslationLab.Currency.cookie.write(currentCurrencyCode);
            sendCurrencyChangeEvent();
        }
        function sendCurrencyChangeEvent() {
            var currencyChangeEvent = new CustomEvent('tlab_currency_change', { detail: { currencyCode: currentCurrencyCode } });
            document.dispatchEvent(currencyChangeEvent);
            document.querySelectorAll('.tl-selected-currency').forEach(function (el) {
                var sp = el.getElementsByTagName('span')[0];
                var img = el.getElementsByTagName('img')[0];
                sp.innerText = currentCurrencyCode;
                if (img) {
                    img.src = imgFileTemplate.replace('[country-code]', currentCurrencyCode.slice(0, 2).toLowerCase().toLowerCase());
                }
            });
        }
        function updatePriceElements(languageCode, targetCurrencyCode) {
            var targetCurrency = findCurrencyForLanguage(languageCurrencies, languageCode, targetCurrencyCode, config.shopCurrencyCode);
            if (!targetCurrency) {
                return;
            }
            Window.TranslationLab.Currency.convertAll(config.shopCurrencyCode, currentCurrencyCode, targetCurrency.code, config.currencyFormatClass);
        }
        function configureDomChangeTracker(onChangeDetected) {
            document.addEventListener('readystatechange', function () {
                document.querySelectorAll('select').forEach(function (element) {
                    element.addEventListener('change', function () {
                        onChangeDetected();
                        setTimeout(onChangeDetected);
                    });
                });
            });
            var targetNode = document.querySelector('body');
            var observerConfig = { attributes: true, childList: true, subtree: true };
            var observerCallback = function (_mutationsList, _observer) {
                onChangeDetected();
            };
            var observer = new MutationObserver(observerCallback);
            observer.observe(targetNode, observerConfig);
        }
        return {
            resetSelection: resetSelection,
            updateCurrencyList: updateCurrencyList,
            acceptCurrencyChange: acceptCurrencyChangeExternal
        };
    }
    function configureLanguageAndCurrencySwitcher(config) {
        var dropdownContainer = dropdownContainerHandler(config, onCancelAction, onAcceptAction);
        var currencySwitcher = configureCurrencySwitcher(config, onCurrencySelect);
        var languageSwitcher = configureLanguageSwitcher(config, onLanguageSelect);
        function onCurrencySelect(currency) {
        }
        function onLanguageSelect(language) {
            if (language) {
                currencySwitcher === null || currencySwitcher === void 0 ? void 0 : currencySwitcher.updateCurrencyList(language);
            }
        }
        function onAcceptAction() {
            currencySwitcher === null || currencySwitcher === void 0 ? void 0 : currencySwitcher.acceptCurrencyChange();
            languageSwitcher === null || languageSwitcher === void 0 ? void 0 : languageSwitcher.acceptLanguageChange();
        }
        function onCancelAction() {
            currencySwitcher === null || currencySwitcher === void 0 ? void 0 : currencySwitcher.resetSelection();
            languageSwitcher === null || languageSwitcher === void 0 ? void 0 : languageSwitcher.resetSelection();
        }
    }
    function configureRegionAndLanguageSwitcher(config) {
        var dropdownContainer = dropdownContainerHandler(config, onCancelAction, onAcceptAction);
        var regionSelectorConfig = {
            containerId: config.currencySwitcherId,
            dropdownSelector: config.dropdownSelector,
            optionsListSelector: config.optionsListSelector,
            itemList: config.availableCountries,
            selectedItem: config.currentCountry,
            generateLabel: function (country) { return country.name; },
            onItemSelect: function (country, container) {
                if (!country) {
                    return;
                }
                var form = container.querySelector('form');
                if (!form) {
                    return;
                }
                var formInputElementResult = container.querySelector('input[name="country_code"]');
                if (!formInputElementResult) {
                    return;
                }
                var formInputElement = formInputElementResult;
                formInputElement.value = country.iso_code;
                form.submit();
            }
        };
        var regionSwitcher = dropdownHandler(regionSelectorConfig);
        var languageSelectorConfig = {
            containerId: config.languageSwitcherId,
            dropdownSelector: config.dropdownSelector,
            optionsListSelector: config.optionsListSelector,
            itemList: config.languageList,
            selectedItem: config.currentLocale,
            generateLabel: function (language) { return config.labelType === 'language-name' ? language.endonym_name : language.display_code; },
            onItemSelect: function (language, container) {
                if (!language) {
                    return;
                }
                var form = container.querySelector('form');
                if (!form) {
                    return;
                }
                var formInputElementResult = container.querySelector('input[name="language_code"]');
                if (!formInputElementResult) {
                    return;
                }
                localStorage.setItem('translation-lab-lang', language.iso_code);
                var formInputElement = formInputElementResult;
                formInputElement.value = language.iso_code;
                form.submit();
            }
        };
        var languageSwitcher = dropdownHandler(languageSelectorConfig);
        function onCancelAction() {
        }
        function onAcceptAction() {
        }
    }
    function configureRegionSwitcher(config) {
        var regionSelectorConfig = {
            containerId: config.currencySwitcherId,
            dropdownSelector: config.dropdownSelector,
            optionsListSelector: config.optionsListSelector,
            itemList: config.availableCountries,
            selectedItem: config.currentCountry,
            generateLabel: function (country) { return country.name; },
            onItemSelect: function (country, container) {
                if (!country) {
                    return;
                }
                var form = container.querySelector('form');
                if (!form) {
                    return;
                }
                var formInputElementResult = container.querySelector('input[name="country_code"], input[name="currency_code"]');
                if (!formInputElementResult) {
                    return;
                }
                var formInputElement = formInputElementResult;
                formInputElement.value = country.iso_code;
                form.submit();
            }
        };
        var regionSwitcher = dropdownHandler(regionSelectorConfig);
    }
    function configureRegionCurrencyAndLanguageSwitcher(config) {
        var dropdownContainer = dropdownContainerHandler(config, onCancelAction, onAcceptAction);
        var regionSelectorConfig = {
            containerId: config.currencySwitcherId,
            dropdownSelector: config.dropdownSelector,
            optionsListSelector: config.optionsListSelector,
            itemList: config.availableCountries,
            selectedItem: config.currentCountry,
            generateLabel: function (country) { return country.name; },
            onItemSelect: function (country, container) {
                if (!country) {
                    return;
                }
                var form = container.querySelector('form');
                if (!form) {
                    return;
                }
                var formInputElementResult = container.querySelector('input[name="country_code"]');
                if (!formInputElementResult) {
                    return;
                }
                var formInputElement = formInputElementResult;
                formInputElement.value = country.iso_code;
                form.submit();
            }
        };
        var regionSwitcher = dropdownHandler(regionSelectorConfig);
        var languageSelectorConfig = {
            containerId: config.languageSwitcherId,
            dropdownSelector: config.dropdownSelector,
            optionsListSelector: config.optionsListSelector,
            itemList: config.languageList,
            selectedItem: config.currentLocale,
            generateLabel: function (language) { return config.labelType === 'language-name' ? language.endonym_name : language.display_code; },
            onItemSelect: function (language, container) {
                if (!language) {
                    return;
                }
                var form = container.querySelector('form');
                if (!form) {
                    return;
                }
                var formInputElementResult = container.querySelector('input[name="language_code"]');
                if (!formInputElementResult) {
                    return;
                }
                localStorage.setItem('translation-lab-lang', language.iso_code);
                var formInputElement = formInputElementResult;
                formInputElement.value = language.iso_code;
                form.submit();
            }
        };
        var languageSwitcher = dropdownHandler(languageSelectorConfig);
        function onCancelAction() {
        }
        function onAcceptAction() {
        }
    }
    if (typeof Window.TranslationLab === 'undefined') {
        Window.TranslationLab = {};
    }
    if (typeof Window.TranslationLab.AdvancedSwitcher === 'undefined') {
        Window.TranslationLab.AdvancedSwitcher = {
            configure: function (config) {
                switch (config.switcherMode) {
                    case 'language_switcher':
                        return configureLanguageSwitcher(config);
                    case 'currency_switcher':
                        return configureCurrencySwitcher(config);
                    case 'language_and_currency_switcher':
                        return configureLanguageAndCurrencySwitcher(config);
                    case 'region_country_and_language_switcher':
                        return configureRegionAndLanguageSwitcher(config);
                    case 'region_country_switcher':
                        return configureRegionSwitcher(config);
                    case 'region_currency_and_language_switcher':
                        return configureRegionCurrencyAndLanguageSwitcher(config);
                }
            }
        };
    }
})(window);
